import * as $ from 'jquery';
import { isBot } from './utils';

function isHalalConsentAccepted() {
  return localStorage.getItem('halalConsentAccepted') === 'true';
}

export function resetHalalConsent() {
  localStorage.removeItem('halalConsentAccepted');
  location.reload();
}

function loadGoogleAds() {
  // Load AdSense script
  const adsScript = document.createElement('script');
  adsScript.src = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-7038748651415966';
  adsScript.async = true;
  adsScript.crossOrigin = 'anonymous';
  document.head.appendChild(adsScript);

  // Load Funding Choices script
  const fundingScript = document.createElement('script');
  fundingScript.src = 'https://fundingchoicesmessages.google.com/i/pub-7038748651415966?ers=1';
  fundingScript.async = true;
  fundingScript.nonce = 'E9s9M8Rb1Qq8DLHQx-ilag';
  document.head.appendChild(fundingScript);

  // Add googlefcPresent signal
  const signalScript = document.createElement('script');
  signalScript.nonce = 'E9s9M8Rb1Qq8DLHQx-ilag';
  signalScript.textContent = `(function() {function signalGooglefcPresent() {if (!window.frames['googlefcPresent']) {if (document.body) {const iframe = document.createElement('iframe'); iframe.style = 'width: 0; height: 0; border: none; z-index: -1000; left: -1000px; top: -1000px;'; iframe.style.display = 'none'; iframe.name = 'googlefcPresent'; document.body.appendChild(iframe);} else {setTimeout(signalGooglefcPresent, 0);}}}signalGooglefcPresent();})();`;
  document.body.appendChild(signalScript);
}

function shakeConsentBanner() {
  const banner = document.getElementById('halal-consent-banner');
  if (!banner) {
    return;
  }

  banner.classList.remove('shake');
  // Force reflow so the animation can restart
  void banner.offsetWidth;
  banner.classList.add('shake');
}

function blockCreateActions(event) {
  event.preventDefault();
  event.stopImmediatePropagation();
  shakeConsentBanner();
}

function createConsentBanner() {
  const halalConsentText = $('body').attr('data-halal-consent');
  const acceptText = $('body').attr('data-halal-accept');

  const bannerHTML = `
    <div id="halal-consent-banner">
      <div class="halal-consent-content">
        <p>${halalConsentText}</p>
        <button id="halal-consent-accept" class="halal-btn-accept">${acceptText}</button>
      </div>
    </div>
  `;

  $('body').append(bannerHTML);

  const $createActions = $('#rand, #choose');
  const $randForm = $('#rand').closest('form');

  $randForm.on('submit.halalConsent', blockCreateActions);
  $createActions.on('click.halalConsent', blockCreateActions);

  $('#halal-consent-accept').on('click', function() {
    localStorage.setItem('halalConsentAccepted', 'true');
    $randForm.off('.halalConsent');
    $createActions.off('.halalConsent');
    $('#halal-consent-banner').fadeOut(300, function() {
      $(this).remove();
    });
    loadGoogleAds();
  });
}

export function showHalalConsent() {
  // Don't show to bots
  if (isBot()) {
    loadGoogleAds(); // Bots should see ads for indexing
    return;
  }

  // If already accepted, load ads immediately
  if (isHalalConsentAccepted()) {
    loadGoogleAds();
    return;
  }

  // Show consent banner for users who haven't accepted
  createConsentBanner();
}

// Reset halal consent if #halal-consent-reset is in the url
if (window.location.hash === '#halal-consent-reset') {
  resetHalalConsent();
}
